import React from "react";

interface BulkActionBarProps {
  /** Number of currently selected rows. The bar hides itself when this is 0. */
  count: number;
  /** Clears the current selection. */
  onClear: () => void;
  /** Action buttons to render, e.g. <Button>Merge</Button>. */
  children: React.ReactNode;
  /** Noun describing a selected row, e.g. "duplicate" -> "3 duplicates selected". */
  itemLabel?: string;
}

/**
 * Floating action bar anchored to the bottom of the viewport, shown while
 * rows are selected in a table. Styles live in assets/scss/custom.scss.
 */
const BulkActionBar = ({
  count,
  onClear,
  children,
  itemLabel = "item",
}: BulkActionBarProps) => {
  if (!count) return null;

  return (
    <div className="bulk-action-bar-wrapper">
      <div className="bulk-action-bar" role="toolbar" aria-label="Bulk actions">
        <span className="bulk-action-bar__count">{count}</span>
        <span className="text-nowrap">
          {itemLabel}
          {count === 1 ? "" : "s"} selected
        </span>

        <span className="bulk-action-bar__divider" />

        <div className="bulk-action-bar__actions">{children}</div>

        <span className="bulk-action-bar__divider" />

        <button
          type="button"
          className="btn btn-ghost-secondary btn-icon btn-sm"
          onClick={onClear}
          title="Clear selection"
          aria-label="Clear selection"
        >
          <i className="ri-close-line fs-16"></i>
        </button>
      </div>
    </div>
  );
};

export default BulkActionBar;
